import React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { MembershipCaclulatorState } from './membershipCaclulatorState'
import { MembershipCaclulatorLayout } from './membershipCalculatorLayout'
import { DataLayer } from '../../utils/datalayer'
import { employeeCount } from './membershipCalculatorUtils'

export const membershipCalculatorWidget = (
  calculatorState: MembershipCaclulatorState
): Widget<Updater<MembershipCaclulatorState>> => {
  return fromJSX<Updater<MembershipCaclulatorState>>(setState => (
    <MembershipCaclulatorLayout
      state={calculatorState}
      // setOrganizationConcerns={(concern: string, checked: boolean) => {
      //   setState(oldState => ({
      //     ...oldState,
      //     organizationConcerns: new Map(
      //       oldState.organizationConcerns.set(concern, checked)
      //     )
      //   }))
      // }}
      setEmployeeCount={(countOption: string) => {
        const count = employeeCount.get(countOption)?.label
        DataLayer.clickMembershipCalculatorEmployeeCount(count ?? "unknown value");
        setState((oldState: MembershipCaclulatorState) : MembershipCaclulatorState => ({
          ...oldState,
          employeeCount: countOption
        }))
      }}
    />
  ))
}
